module.exports = __webpack_public_path__ + "static/img/fourLast.248fc8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fourLast.png
// module id = qntq
// module chunks = 1